import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { PartnerStore } from '@app/partners/model/partner.model';
import { PartnerStoreComponent } from '../partner-store/partner-store.component';

@Component({
    selector: 'app-partner-stores',
    templateUrl: './partner-stores.component.html',
    styleUrls: ['./partner-stores.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PartnerStoreComponent],
})
export class PartnerStoresComponent {
    @Input({ required: true }) stores!: PartnerStore[];
}
